import { api } from "../../src/component/constent";


// ============================================================
// CURRENT MONTH
// ============================================================

export const getWLSCurrentMonth = () => {

    return api.get("/entry/current-month" );

};


// ============================================================
// GET WLS
// ============================================================

export const getWLS = (month, year) => {

    return api.get( "/entry/wls",  {
            params: {
                month,
                year
            }
        }
    );

};


// ============================================================
// SAVE WLS
// ============================================================

export const saveWLS = (data) => {

    return api.post(
        "/entry/wls",
        data
    );

};


// ============================================================
// DELETE WLS
// ============================================================

export const deleteWLS = (month, year) => {

    return api.delete(
        "/entry/wls",
        {
            params: {
                month,
                year
            }
        }
    );

};